/** Раздел F, умение: экзамен, собеседование, торг, поле, права, музыка, готовка (F1–F7). */
import type { MinigameDef } from '../types';
import { bargain } from './bargain';
import { busking } from './busking';
import { cooking } from './cooking';
import { driving } from './driving';
import { exam } from './exam';
import { field } from './field';
import { interview } from './interview';

export const SKILL_MINIGAMES: MinigameDef[] = [
  exam as MinigameDef,
  interview as MinigameDef,
  bargain as MinigameDef,
  field as MinigameDef,
  driving as MinigameDef,
  busking as MinigameDef,
  cooking as MinigameDef,
];

export { exam, interview, bargain, field, driving, busking, cooking };
